"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopIconComponent = void 0;
const core_1 = require("@angular/core");
const common_1 = require("@angular/common");
let DesktopIconComponent = class DesktopIconComponent {
    constructor() {
        this.app = core_1.input.required();
        this.launch = (0, core_1.output)();
        this.dragStart = (0, core_1.output)();
        this.launchWithFile = (0, core_1.output)();
        this.isDragOver = (0, core_1.signal)(false);
    }
    onDragStart(event) {
        this.dragStart.emit({ event, app: this.app() });
        const img = new Image();
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
        event.dataTransfer.setDragImage(img, 0, 0);
    }
    onDragOver(event) {
        const isFileDrag = event.dataTransfer?.types.includes('application/webos-file-path');
        if (isFileDrag) {
            event.preventDefault();
            this.isDragOver.set(true);
        }
    }
    onDragLeave() {
        this.isDragOver.set(false);
    }
    onDrop(event) {
        event.preventDefault();
        this.isDragOver.set(false);
        const filePath = event.dataTransfer?.getData('application/webos-file-path');
        if (filePath) {
            this.launchWithFile.emit({ appId: this.app().id, filePath });
        }
    }
};
exports.DesktopIconComponent = DesktopIconComponent;
exports.DesktopIconComponent = DesktopIconComponent = __decorate([
    (0, core_1.Component)({
        selector: 'app-desktop-icon',
        // Fix: Set ChangeDetectionStrategy to OnPush for better performance with signal-based components.
        changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        imports: [common_1.CommonModule],
        template: `
@let appData = app();
<div
  draggable="true"
  (dragstart)="onDragStart($event)"
  (dblclick)="launch.emit(appData.id)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
  class="absolute flex flex-col items-center justify-center w-24 h-24 p-2 rounded-lg hover:bg-white/10 cursor-pointer select-none text-center transition-colors"
  [class.bg-blue-500/30]="isDragOver()"
  [style.left.px]="appData.position?.x"
  [style.top.px]="appData.position?.y"
>
  <img [src]="appData.icon" [alt]="appData.name" class="w-10 h-10 mb-1 drop-shadow-lg">
  <span class="text-xs text-white [text-shadow:0_1px_2px_rgba(0,0,0,0.8)] truncate w-full">{{ appData.name }}</span>
</div>`,
    })
], DesktopIconComponent);
